import { Navigate, Route, Routes } from 'react-router-dom';
import { ErrorBoundary } from '@components/error-boundary';
import { AppLayout } from '@shared/layouts/app-layout/app-layout.view';
import { PublicLayout } from '@shared/layouts/public-layout/public-layout.view';
import { appPublicRoutes, basePublicRoutes, demoRoutes } from './routes/route-public';
import { basePrivateRoutes, appPrivateRoutes } from './routes/route-private';
import { flatNestedRoutes } from './routes/route-helper';
import PrivateProviders from '@/container/context/private.providers';
import { AppBootstrap } from '@shared/app-bootstrap/app-bootstrap';
import { RolePrivilegeWrapper } from '@components/role/role-privilege-wrapper';
import { AuthGuard } from '@modules/auth/common/auth-guard';
import { RoleGuard } from '@components/role/role-guard';
import { PlanGuard } from '@components/role/plan-guard';
import { useAppRoute } from './use-route';
import { SubscriptionsManager } from '@shared/app-bootstrap/subscription-manager/subscriptions-manager';
import { PublicContainer } from './public-container';

export function Routers() {
  const flatBasePrivateRoutes = flatNestedRoutes(basePrivateRoutes);
  const flatBasePublicRoutes = flatNestedRoutes(basePublicRoutes);
  const flatAppPublicRoutes = flatNestedRoutes(appPublicRoutes);
  const flatAppPrivateRoutes = flatNestedRoutes(appPrivateRoutes);
  const flatDemoRoutes = flatNestedRoutes(demoRoutes);

  const { isLoggedIn } = useAppRoute();

  if (!isLoggedIn) {
    return (
      <PublicContainer>
        <Routes>
          {flatDemoRoutes.map((route) => (
            <Route
              key={route.path}
              path={route.path}
              element={
                <ErrorBoundary>
                  <route.component />
                </ErrorBoundary>
              }
            />
          ))}

          {flatBasePublicRoutes.map((route) => (
            <Route
              key={route.path}
              path={route.path}
              element={
                <ErrorBoundary>
                  <route.component />
                </ErrorBoundary>
              }
            />
          ))}

          {flatAppPublicRoutes.map((route) => (
            <Route
              key={route.path}
              path={route.path}
              element={
                <PublicLayout>
                  <ErrorBoundary>
                    <route.component />
                  </ErrorBoundary>
                </PublicLayout>
              }
            />
          ))}

          <Route path="/auth/signup" element={<Navigate to="/sign-up" replace />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </PublicContainer>
    );
  }

  return (
    <RolePrivilegeWrapper>
      <>
        <SubscriptionsManager />
        <AppBootstrap>
          <PrivateProviders>
            <Routes>
              {flatDemoRoutes.map((route) => (
                <Route
                  key={route.path}
                  path={route.path}
                  element={
                    <ErrorBoundary>
                      <route.component />
                    </ErrorBoundary>
                  }
                />
              ))}

              {flatBasePrivateRoutes.map((route) => (
                <Route
                  key={route.path}
                  path={route.path}
                  element={
                    <ErrorBoundary>
                      <route.component />
                    </ErrorBoundary>
                  }
                />
              ))}
              {flatAppPrivateRoutes.map((route) => (
                <Route
                  key={route.path}
                  path={route.path}
                  element={
                    <AuthGuard>
                      <RoleGuard roles={route.rolePrivilege}>
                        <PlanGuard plans={route.planPrivilege}>
                          <AppLayout breadcrumbs={route.breadcrumbs} pageSize={route.pageSize}>
                            <ErrorBoundary>
                              <route.component />
                            </ErrorBoundary>
                          </AppLayout>
                        </PlanGuard>
                      </RoleGuard>
                    </AuthGuard>
                  }
                />
              ))}
            </Routes>
          </PrivateProviders>
        </AppBootstrap>
      </>
    </RolePrivilegeWrapper>
  );
}
